import './App.css';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRouter from './Routes/AppRouter';
function App() {
  return (
    <div className="App">
        <AppRouter/>
    </div>
  );
}

export default App;
